import { Expander, ExpanderContent, ExpanderHeader, ResponsiveTableRow, H5 } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from '@fs/zion-router'
import { DmcResponsiveTable } from '../../common/DmcResponsiveTable'
import { toLocaleRelativeString } from '../../../util/DateUtil'
import useArtifactDiscussion from '../../../hooks/artifacts/useArtifactDiscussion'
import { getFrontendBaseUrl } from '../../../util/UrlUtil'

/**
 * Displays information about the artifact’s comments, and provides
 * a link to the comments in the Sources and Discussions Admin tool.
 */
export default function CommentsPanel({ artifactId }) {
  const [t] = useTranslation()
  const title = t('artifacts.comments', 'Comments')
  const { discussion } = useArtifactDiscussion(artifactId)
  const columnHeaders = ['', ' ']

  if (!discussion) {
    return null
  }
  const { commentCount, id, uniqueCommenterCount, lastComment } = discussion
  return (
    <Expander>
      <ExpanderHeader>
        <H5>{`${title} (${commentCount})`}</H5>
      </ExpanderHeader>
      <ExpanderContent>
        <DmcResponsiveTable
          totalColumnCount={columnHeaders.length}
          atSizeColumns={{
            default: {
              labels: columnHeaders,
            },
          }}
          separator={<br />}
        >
          <ResponsiveTableRow
            column1={t('artifacts.comments', 'Comments')}
            column2={
              <div>
                {`${commentCount} ${t('artifacts.comments', 'Comments')}`}
                <br />
                <Link
                  to={`${getFrontendBaseUrl(true)}/tree/sources/admin?discussionId=${id}`}
                  target="_blank"
                  noScrollTop
                >
                  {t('artifacts.seeAllComments', 'See All Comments (Discussions Admin)')}
                </Link>
              </div>
            }
          />
          <ResponsiveTableRow
            column1={t('artifacts.uniqueCommenters', 'Unique Commenters')}
            column2={uniqueCommenterCount}
          />
          <ResponsiveTableRow
            column1={t('artifacts.latestComment', 'Latest Comment')}
            column2={
              <div>
                {lastComment.text}
                <br />
                <i>({toLocaleRelativeString(new Date(lastComment.createdDate), new Date())})</i>
              </div>
            }
          />
        </DmcResponsiveTable>
      </ExpanderContent>
    </Expander>
  )
}
